import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Link } from 'foundations-components/transitional/components/Link';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledAIInfoIcon = styled.div.withConfig({
  displayName: "ContentAssistantOnboardingPopover__StyledAIInfoIcon"
})(["position:absolute;top:-27px;left:-7px;cursor:pointer;"]);
export const ContentAssistantOnboardingPopover = props => {
  const {
    AIInfoIconOpen,
    setAIInfoIconOpen,
    setHasSeenAIOnboardingPopover,
    settingsUrl
  } = props;
  return /*#__PURE__*/_jsx(Popover, {
    inlineSize: "350px",
    "data-test-id": "content-assistant-ai-onboarding-popover",
    use: "shepherd",
    open: AIInfoIconOpen,
    showCloseButton: true,
    onOpenChange: evt => {
      setAIInfoIconOpen(evt.target.value);
      setHasSeenAIOnboardingPopover();
    },
    content: {
      header: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'hubspot-prosemirror.onboardingPopover.header'
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "hubspot-prosemirror.onboardingPopover.body_jsx",
        elements: {
          Link
        },
        options: {
          href: settingsUrl,
          external: true
        }
      }),
      footer: /*#__PURE__*/_jsx(ButtonWrapper, {
        justify: "end",
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: setHasSeenAIOnboardingPopover,
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'hubspot-prosemirror.onboardingPopover.button'
          })
        })
      })
    },
    children: /*#__PURE__*/_jsx(StyledAIInfoIcon, {
      onClick: () => setAIInfoIconOpen(!AIInfoIconOpen),
      children: /*#__PURE__*/_jsx(InfoIcon, {
        "data-test-id": "content-assistant-ai-info-icon",
        size: "700",
        color: "fill-accent-purple-default"
      })
    })
  });
};